export default {
      id: "pen-tool-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#pen-tool-usage",
      toString: function () {
        return this.url;
      }
    }